export const BRAND = {
  whatsapp: "https://wa.me/5561995814792",
  whatsappPretty: "(61) 9 9581-4792",
  webhook: "https://n8n.andrewmendes.com.br/webhook/Sitevemais",
  instagram: "https://www.instagram.com/oticavemaisss",
  instagramHandle: "@oticavemaisss",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_optica-vplus/artifacts/0jg5pmgt_Gemini_Generated_Image_.png",
  storeImages: {
    front:
      "https://customer-assets.emergentagent.com/job_optica-vplus/artifacts/lzwc1vr7_2026-04-22.webp",
    facade:
      "https://customer-assets.emergentagent.com/job_optica-vplus/artifacts/744ovnox_2026-04-22%20%283%29.webp",
    interiorMen:
      "https://customer-assets.emergentagent.com/job_optica-vplus/artifacts/gvc72drc_2026-04-22%20%281%29.webp",
    interiorWomen:
      "https://customer-assets.emergentagent.com/job_optica-vplus/artifacts/cbv2k6f1_2026-04-22%20%282%29.webp",
  },
  hero: "https://images.pexels.com/photos/36004403/pexels-photo-36004403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
  products: {
    sun: "https://images.pexels.com/photos/29488636/pexels-photo-29488636.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
    grau: "https://images.pexels.com/photos/30271002/pexels-photo-30271002.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
    masculino:
      "https://images.unsplash.com/photo-1764179627974-25d96c2a1e97?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    feminino:
      "https://images.pexels.com/photos/15759109/pexels-photo-15759109.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
    infantil:
      "https://images.unsplash.com/photo-1742321694002-77d33db25f68?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    premium:
      "https://images.pexels.com/photos/36004403/pexels-photo-36004403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  },
};
